"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var UpTrend = function UpTrend(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.804 7.244a.606.606 0 00-.64-.548l-3.744.288a.596.596 0 00-.548.64c.024.332.324.56.64.548l2.396-.184L11.8 11.04 8.564 8.148a.595.595 0 00-.78-.012l-4.896 4.116a.596.596 0 10.768.912l4.5-3.784 3.268 2.92c.232.212.592.2.816-.02l3.496-3.428.048 2.228a.6.6 0 00.596.552h.048a.596.596 0 00.548-.64l-.172-3.748z",
    fill: color
  }));
};
var _default = exports["default"] = UpTrend;